import {
  Navigate,
  RouterProvider,
  createBrowserRouter,
} from 'react-router-dom';
import AuthOnly from '../components/AuthOnly';
import LoadUserInfo from '../components/LoadUserInfo';
import NoAuthOnly from '../components/NoAuthOnly';
import { EUserRoles } from '../models/user.model';
import BlogRouting from './blog';
import CategoryRouting from './category';
import ContactSubmissionRouting from './contact-submission';
import DashboardPage from './dashboard';
import FaqRouting from './faq';
import GreenHubRouting from './green-hub';
import MainPage from './main';
import MentorRouting from './mentor';
import NewsletterRouting from './newsletter';
import NotFoundPage from './not-found';
import PartnerRouting from './partner';
import PhaseRouting from './phase';
import PortfolioRouting from './portfolio';
import RegionRouting from './region';
import SignInPage from './sign-in';
import TopicRouting from './topic';
import TrainingDocumentRouting from './training-document';
import UserRouting from './user';

const router = createBrowserRouter([
  {
    path: '/',
    element: (
      <AuthOnly>
        <LoadUserInfo>
          <MainPage />
        </LoadUserInfo>
      </AuthOnly>
    ),
    children: [
      {
        path: '/dashboard',
        element: <DashboardPage />,
      },
      {
        path: '/blog/*',
        element: (
          <AuthOnly roles={[EUserRoles.Admin, EUserRoles.Editor]}>
            <BlogRouting />
          </AuthOnly>
        ),
      },
      {
        path: '/green-hub/*',
        element: (
          <AuthOnly roles={[EUserRoles.Admin, EUserRoles.Editor]}>
            <GreenHubRouting />
          </AuthOnly>
        ),
      },
      {
        path: '/newsletter/*',
        element: (
          <AuthOnly roles={[EUserRoles.Admin, EUserRoles.Editor]}>
            <NewsletterRouting />
          </AuthOnly>
        ),
      },
      {
        path: '/faq/*',
        element: (
          <AuthOnly roles={[EUserRoles.Admin, EUserRoles.Editor]}>
            <FaqRouting />
          </AuthOnly>
        ),
      },
      {
        path: '/contact-submission/*',
        element: (
          <AuthOnly roles={[EUserRoles.Admin]}>
            <ContactSubmissionRouting />
          </AuthOnly>
        ),
      },
      {
        path: '/partner/*',
        element: (
          <AuthOnly roles={[EUserRoles.Admin, EUserRoles.Editor]}>
            <PartnerRouting />
          </AuthOnly>
        ),
      },
      {
        path: '/mentor/*',
        element: (
          <AuthOnly roles={[EUserRoles.Admin, EUserRoles.Editor]}>
            <MentorRouting />
          </AuthOnly>
        ),
      },
      {
        path: '/user/*',
        element: (
          <AuthOnly roles={[EUserRoles.Admin]}>
            <UserRouting />
          </AuthOnly>
        ),
      },
      {
        path: '/start-up/*',
        element: (
          <AuthOnly roles={[EUserRoles.Admin, EUserRoles.Editor]}>
            <CategoryRouting />
          </AuthOnly>
        ),
      },
      {
        path: '/investor/*',
        element: (
          <AuthOnly roles={[EUserRoles.Admin, EUserRoles.Editor]}>
            <TopicRouting />
          </AuthOnly>
        ),
      },
      {
        path: '/region/*',
        element: (
          <AuthOnly roles={[EUserRoles.Admin, EUserRoles.Editor]}>
            <RegionRouting />
          </AuthOnly>
        ),
      },
      // {
      //   path: '/phase/*',
      //   element: (
      //     <AuthOnly roles={[EUserRoles.Admin, EUserRoles.Editor]}>
      //       <PhaseRouting />
      //     </AuthOnly>
      //   ),
      // },
      {
        path: '/portfolio/*',
        element: (
          <AuthOnly roles={[EUserRoles.Admin, EUserRoles.Editor]}>
            <PortfolioRouting />
          </AuthOnly>
        ),
      },
      {
        path: '/training-document/*',
        element: (
          <AuthOnly roles={[EUserRoles.Admin, EUserRoles.Editor]}>
            <TrainingDocumentRouting />
          </AuthOnly>
        ),
      },
      {
        path: '/',
        element: <Navigate to="/dashboard" />,
      },
      {
        path: '*',
        element: <NotFoundPage />,
      },
    ],
  },
  {
    path: '/sign-in',
    element: (
      <NoAuthOnly>
        <SignInPage />
      </NoAuthOnly>
    ),
  },
]);

export default function RootRouter() {
  return <RouterProvider router={router} />;
}
